import {
  clearList,
  getMissionsRequest,
  getMissionsSuccess,
  getMissionsFailed,
  clearTotalMission,
  getTotalMissionRequest,
  getTotalMissionSuccess,
  getTotalMissionFailed,
  GetAllPayload
} from '../reducers/missionSlice'
import { all, call, fork, put } from '@redux-saga/core/effects'
import { AxiosError } from 'axios'
import { PayloadAction } from '@reduxjs/toolkit'
import { take } from 'redux-saga/effects'
import missionApi from '../../http/missionApi'
import { MissionArrayInterface, MissionTotalInterface } from '../../models'
import Define from '../../constants/define'

function* fetchTotalMissions(payload: GetAllPayload) {
  try {
    if (localStorage.getItem(Define.CHOOSING_CLIENT)) {
      const item: MissionTotalInterface = yield call( missionApi.getTotalMission, {} )
      yield put(getTotalMissionSuccess(item))
    } else {
      yield put(clearTotalMission())
    }
  } catch (error) {
    if (error instanceof AxiosError) {
      yield put(getTotalMissionFailed(error.response?.data.error))
    } else {
      yield put(getTotalMissionFailed('Something went wrong'))
    }
  }
}

function* fetchMissions(payload: GetAllPayload) {
  try {
    if (localStorage.getItem(Define.CHOOSING_CLIENT)) {
      const item: MissionArrayInterface = yield call( missionApi.getAllMission, {} )
      yield put(getMissionsSuccess(item))
    } else {
      yield put(clearList())
    }
  } catch (error) {
    if (error instanceof AxiosError) {
      yield put(getMissionsFailed(error.response?.data.error))
    } else {
      yield put(getMissionsFailed('Something went wrong'))
    }
  }
}

function* watchTotalMissionFlow() {
  while (true) {
    const type: PayloadAction<GetAllPayload> = yield take(getTotalMissionRequest.type)
    if (type) {
      yield fork(fetchTotalMissions, type.payload)
    }
  }
}

function* watchMissionFlow() {
  while (true) {
    const type: PayloadAction<GetAllPayload> = yield take(getMissionsRequest.type)
    if (type) {
      yield fork(fetchMissions, type.payload)
    }
  }
}

export default function* missionSaga() {
  yield all([
    fork(watchMissionFlow),
    fork(watchTotalMissionFlow)
  ])
}
